import { Component, OnInit } from "@angular/core";
import { RouterLink, Router } from "@angular/router";

@Component({
    selector: "app-travel-policy-faq-panel",
    standalone: true,
    imports: [RouterLink],
    templateUrl: "./travel-policy-faq-panel.component.html",
    styleUrl: "./travel-policy-faq-panel.component.scss",
})
export class TravelPolicyFaqPanelComponent implements OnInit{
    address: string = '';

    constructor(
        private router: Router
    ) { }

    ngOnInit(): void {
        this.address = this.router.url;
    }
}
